import { render, staticRenderFns } from "./BonsPlans.vue?vue&type=template&id=ba8b85ea&"
import script from "./BonsPlans.vue?vue&type=script&lang=js&"
export * from "./BonsPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports